import { Cartographie } from './carte/carte';
import { recherche } from './carte/recherche';
import { trierParAlphabet, distanceEntre } from './carte/utils';

$(document).ready(function() {
    /**
     * Ajout de startsWith au prototype de string pour le support IE11
     * (permet de voir si un string commence par un autre)
     */
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    ////////////////// CUSTOM SCROLLBARS //////////////////
    $('.carteInteractive-onglets-scroll').mCustomScrollbar();

    /**
     * On demande à l'utilisateur l'accès à la geoloc. On trie les points par ordre alphabétique par défaut.
     */
    points = trierParAlphabet(points, 'ville');
    navigator.geolocation.getCurrentPosition(
        function(position) {
            //si l'utilisateur accepte un crée l'objet cartographie avec la lat et lng de l'utilisateur.
            window.carto = new Cartographie(true, points, position.coords.latitude, position.coords.longitude);
        },
        function(error) {
            //en cas d'erreur on crée l'objet cartographie sans (false veux dire que l'utilisateur refuse)
            window.carto = new Cartographie(false, points);
        }
    );

    $('.carteInteractive-localisezMoi').click(function() {
        navigator.geolocation.getCurrentPosition(function(position) {
            //si l'utilisateur accepte un crée l'objet cartographie avec la lat et lng de l'utilisateur.
            //window.carto = new Cartographie(true, points, position.coords.latitude, position.coords.longitude);
            window.carto.map.setView([position.coords.latitude, position.coords.longitude]);
        });

        return false;
    });

    let timer; // contient l'interval pour executer la fonction
    const interval = 500; // temps de delay en millisecondes

    // Ceci permet d'eviter trop de rafraichissement
    $('#boite-de-recherche').keyup((e) => {
        clearTimeout(timer);
        timer = setTimeout(function(){rechercheCarte()}, interval);
    });
    $('#boite-de-recherche').keydown(() => {
        clearTimeout(timer);
    });

    /**
     * Fonction permettant de faire des recherches sur la carte en asynchrone
     */
    async function rechercheCarte() {
        const textRecherche = $('#boite-de-recherche').val();
        if (textRecherche.length < 1) {
            $.each(points, (i) => {
                $(`#bouton-selection-mag-${points[i].id}`).fadeIn(500, function() {
                    $(this).show();
                }); // on affiche les points de show[]
            });
            $('#no_canada').remove();
            $('#no_france').remove();
        }
        if (textRecherche.length >= 2) {
            var show = []; // on initialise l'array pour stocker les points qui corresponde a la recherche
            var france_nb = 0;
            var canada_nb = 0;
            $.each(points, (i) => {
                if (recherche(textRecherche, points[i])) show.push(points[i]);
            });
            var hidden = points.filter((n) => !(show.indexOf(n) != -1)); // on determine les points à cacher avec un filtre
            
            if (show.length <= 0) {
                // appel a l'api openstreetmap, on recupere uniquement en France et au Canada
                await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=fr,ca&q=${textRecherche}`)
                    .then(async (json) => await json.json())
                    .then((res) => {
                        if (res.length < 1) {
                            return;
                        }
                        // on crée un objet latitude longitude de la recherche
                        let latLng = {lat: res[0].lat, lng: res[0].lon};
                        // on fait une copie des points cacher
                        let pointRegarder = [...hidden];
                        hidden = [];
                        // pour chaque point on regarde la distance et si la distance est trop grande on le cache
                        pointRegarder.forEach(point => {
                            let latLngCible = {lat: point.latitude, lng: point.longitude}
                            let distance = distanceEntre(latLng, latLngCible);
                            if (distance <= 20) {
                                show.push(point);
                            } else {
                                hidden.push(point);
                            }
                        });    
                    });
            }

            $.each(hidden, (i) => {
                $(`#bouton-selection-mag-${hidden[i].id}`).fadeOut(500, function() {
                    $(this).hide();
                }); // on masque les points de hidden[]
            });

            $.each(show, (i) => {
                $(`#bouton-selection-mag-${show[i].id}`).fadeIn(500, function() {
                    $(this).show();
                }); // on affiche les points de show[]
                if (show[i].pays.toLowerCase() == 'france') {
                    france_nb++;
                } else {
                    canada_nb++;
                }
            });

            if (france_nb <= 0) {
                if (!$('#no_france').length) $('#france').append(`<div class="noItem" id="no_france">${aucunLieu}`);
            } else {
                $('#no_france').remove();
            }

            if (canada_nb <= 0) {
                if (!$('#no_canada').length) $('#canada').append(`<div class="noItem" id="no_canada">${aucunLieu}`);
            } else {
                $('#no_canada').remove();
            }
        }
    }

    $('#recherche-form').submit((e) => {
        e.preventDefault();
    });
});
